module.exports = __webpack_public_path__ + "static/box.de0af276.png";